import { Box } from '@inflearn/ds-react-next';

export const ZigzagLights = () => {
  const pastelColors = [
    { r: 255, g: 82, b: 82 }, // 빨강
    { r: 255, g: 112, b: 67 }, // 빨강-오렌지
    { r: 255, g: 152, b: 0 }, // 오렌지
    { r: 255, g: 193, b: 7 }, // 오렌지-노랑
    { r: 255, g: 224, b: 130 }, // 노랑
    { r: 255, g: 235, b: 59 }, // 밝은 노랑
    { r: 255, g: 245, b: 157 }, // 라이트 노랑
    { r: 255, g: 87, b: 34 }, // 딥 오렌지
    { r: 255, g: 152, b: 0 }, // 앰버
    { r: 255, g: 193, b: 7 }, // 골드 옐로우
  ];

  // 그리드 기반 패턴으로 배경 전체를 고르게 덮기
  const gridCols = 10; // 가로 10개
  const gridRows = 6; // 세로 6개
  const totalLights = gridCols * gridRows;

  const zigzagLights = Array.from({ length: totalLights }, (_, i) => {
    const col = i % gridCols;
    const row = Math.floor(i / gridCols);

    // 각 셀의 seed를 다르게 설정하여 랜덤성 확보
    const seed = i * 7919 + col * 997 + row * 499; // 소수를 사용하여 패턴 중복 방지
    const pseudoRandom = (s: number, max: number) => (((s * 9301 + 49297) % 233280) / 233280) * max;

    // 그리드 셀 내에서 랜덤 오프셋 적용
    const cellWidth = 100 / gridCols;
    const cellHeight = 480 / gridRows;
    const xOffset = pseudoRandom(seed + 100, cellWidth * 0.6); // 셀의 60% 범위 내에서 오프셋
    const yOffset = pseudoRandom(seed + 200, cellHeight * 0.6);

    const xPos = col * cellWidth + xOffset;
    const yPos = row * cellHeight + yOffset;

    // 색상을 seed 기반으로 랜덤하게 선택하여 더 다양한 색상 분포
    const colorIndex = Math.floor(pseudoRandom(seed + 500, pastelColors.length));

    const selectedColor = pastelColors[colorIndex];
    const colorWithOpacity = `rgba(${selectedColor.r}, ${selectedColor.g}, ${selectedColor.b}, 0.75)`;

    return {
      id: i,
      color: colorWithOpacity,
      left: `${xPos}%`,
      top: `${20 + yPos}px`, // padding 고려하여 20px부터 시작
      delay: `${pseudoRandom(seed + 300, 2)}s`,
      size: `${pseudoRandom(seed + 400, 3) + 6}px`, // 6~9px 범위로 크기 축소
    };
  });

  return (
    <>
      <style>
        {`
          @keyframes twinkleLight {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.4; transform: scale(0.85); }
          }
          @keyframes glowPastel {
            0%, 100% { filter: brightness(1.3); }
            50% { filter: brightness(1.8); }
          }
        `}
      </style>
      {zigzagLights.map((light) => (
        <Box
          key={light.id}
          pos="absolute"
          top={light.top}
          left={light.left}
          w={light.size}
          h={light.size}
          css={{
            borderRadius: '50%',
            backgroundColor: light.color,
            animation: `twinkleLight 1.8s ease-in-out infinite, glowPastel 1.8s ease-in-out infinite`,
            animationDelay: light.delay,
            zIndex: 1,
            boxShadow: `0 0 8px ${light.color}, 0 0 12px ${light.color}, 0 0 16px ${light.color}`,
          }}
        />
      ))}
    </>
  );
};
